import { h, Host } from "@stencil/core";
export class SidebarContent {
    render() {
        return (h(Host, { key: '07faf166a39a5018e376b44ea3b84ab2ef416108', class: "ux-sidebar-content" }, h("slot", { key: 'bc9462715978c5c0599924474ef3d654ecf2ae51' })));
    }
    static get is() { return "ux-sidebar-content"; }
    static get originalStyleUrls() {
        return {
            "$": ["sidebar-content.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["sidebar-content.css"]
        };
    }
}
//# sourceMappingURL=sidebar-content.js.map
